var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0675 30.9258V58.2513C54.0675 59.135 53.3511 59.8513 52.4675 59.8513H9.38662C8.50296 59.8513 7.78662 59.135 7.78662 58.2513V30.9258",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2511 16.4615H3.6C2.71634 16.4615 2 17.1779 2 18.0615V29.3243C2 30.208 2.71634 30.9243 3.6 30.9243H58.2511C59.1347 30.9243 59.8511 30.208 59.8511 29.3243V18.0615C59.8511 17.1779 59.1347 16.4615 58.2511 16.4615Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9263 59.8498V16.4615",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4323 14.5797C30.7244 15.5462 29.9838 16.4628 28.9742 16.4628H17.9094C15.9915 16.4628 14.1521 15.7009 12.796 14.3447C11.4399 12.9886 10.678 11.1493 10.678 9.23138C10.678 7.3135 11.4399 5.47417 12.796 4.11802C14.1521 2.76188 15.9915 2 17.9094 2C25.7447 2 29.2486 10.6631 30.4323 14.5797Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4198 14.5797C31.1277 15.5462 31.8683 16.4628 32.878 16.4628H43.9428C45.8606 16.4628 47.7 15.7009 49.0561 14.3447C50.4123 12.9886 51.1741 11.1493 51.1741 9.23138C51.1741 7.3135 50.4123 5.47417 49.0561 4.11802C47.7 2.76188 45.8606 2 43.9428 2C36.1074 2 32.6036 10.6631 31.4198 14.5797Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.883f0bf0.svg";
export { ForwardRef as ReactComponent };